import { render, staticRenderFns } from "./creditNote.vue?vue&type=template&id=ec498ba4&scoped=true&"
import script from "./creditNote.vue?vue&type=script&lang=js&"
export * from "./creditNote.vue?vue&type=script&lang=js&"
import style0 from "./creditNote.vue?vue&type=style&index=0&id=ec498ba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec498ba4",
  null
  
)

export default component.exports